import { pxToRem } from '@/shared/styles/themes'
import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material'

import { PixieWorldIcon } from '../Icon/PixieWorldIcon'

export const StyledAccordion = styled(Accordion)`
  background-color: transparent;
  box-shadow: none;
  border-bottom: 1px solid ${props => props.theme.palette.text.disabled};
  border-radius: 0 !important;

  ${props => props.theme.breakpoints.up('sm')} {
    display: none;
  }
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0;

  .MuiAccordionSummary-expandIconWrapper {
    color: ${props => props.theme.palette.custom.footer.text};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    display: none;
  }
`

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding-left: 0;
  padding-right: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    display: none;
  }
`

export const StyledAngleIcon = styled(PixieWorldIcon)`
  color: ${props => props.theme.palette.custom.footer.text};
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
`
